import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import AboutUsPage from '../components/AboutUsPage';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';

const AboutUsFullPage = () => {
    const [site, setSite] = useState(null);
    const [aboutUs, setAboutUs] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get('/content/site'),
            api.get('/content/aboutUs'),
        ])
            .then(([siteRes, aboutRes]) => {
                setSite(siteRes.data);
                setAboutUs(aboutRes.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading about content:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!site || !aboutUs) {
        return (
            <div className="error-screen">
                <h1>Error loading content</h1>
                <p>Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="App">
            <MetaTags
                title="About Us | Melbourne Nepalese Community West"
                description="Learn about Melbourne Nepalese Community West (MNCW) - our mission, vision, history, and the team dedicated to serving the Nepali community in Melbourne's western suburbs."
                url="https://mncw.org.au/about-us"
                image="https://mncw.org.au/assets/img/logo.jpg"
                type="website"
            />
            <Header data={site} />
            <div style={{ marginTop: '128px' }}>
                <AboutUsPage data={aboutUs} />
            </div>
            <Footer data={site} />
        </div>
    );
};

export default AboutUsFullPage;
